import React, { FC, useEffect, useState } from "react";
import services from "utils/services";
import { Link } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { PlusIcon } from "@heroicons/react/24/solid";

export interface ShiftPageProps {
	className?: string;
}

const ShiftPage: FC<ShiftPageProps> = ({ className = "" }) => {
	const [shiftList, setShiftList] = useState<any>([]);
	useEffect(() => {
		getShift();
	}, []);

	const getShift = () => {
		services.getShifts(
			{},
			(success) => {
				setShiftList(success.shifts);
			},
			(error) => console.error(error)
		);
	};
	const renderShift = (shift: any, index: number) => {
		const { name, schedule } = shift;
		return (
			<div key={index}>
				<hr className="mt-3 border-slate-200 dark:border-slate-700"></hr>

				<div className="flex flex-row items-center pt-3 sm:pt-3 last:pb-0 first:pt-0">
					<span className={`w-[30%]`}>{name}</span>
					<div className="w-[25%]">
						{schedule.map((s: any, index: number) => {
							return (
								<div key={index}>
									<span>{s.day} : </span>
									<span>
										{s.isDayOff
											? "Repos"
											: s.timeSlots.map(
													(t: any, index: number) =>
														t.fromHour +
														"-" +
														t.toHour +
														(index < s.timeSlots.length - 1 ? " | " : "")
											  )}
									</span>
								</div>
							);
						})}
					</div>
					<div className="w-[10%] flex justify-end">
						<Link
							className="w-10 h-10 sm:w-12 sm:h-12 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full flex items-center justify-center text-right"
							to={"/shift/" + shift._id}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								strokeWidth="1.5"
								stroke="currentColor"
								className="w-6 h-6"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
								/>
							</svg>
						</Link>
					</div>
				</div>
			</div>
		);
	};

	return (
		<div className={`nc-ShiftPage ${className}`} data-nc-id="ShiftPage">
			<div className="container">
				<div className="space-y-10 sm:space-y-12">
					{/* HEADING */}
					<div className="max-w-4xl mx-auto pt-2 pb-2">
						{/* <CommonLayout> */}
						<div className="flex flex-row items-center justify-between">
							<div className="space-y-2 sm:space-y-2 ">
								<h1 className="text-3xl font-bold">Liste des Shifts</h1>
							</div>
							<div className="m-5 pt-2">
								<ButtonSecondary
									href="/shift"
									className="!bg-slate-200 hover:!bg-slate-100 border-2 border-neutral-400"
								>
									<PlusIcon className="w-5 h-5 mr-2 -ml-1" aria-hidden="true" />
									Ajouter
								</ButtonSecondary>
							</div>
						</div>

						<div className="flex flex-col">
							{/* <span className="w-[30%] text-xl font-medium">
								Liste des Shifts
							</span> */}
							{/* <span className="w-[25%] font-medium">Email</span> */}
							<span></span>
							{/* </CommonLayout> */}
							{shiftList.map((user: any, index: number) =>
								renderShift(user, index)
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ShiftPage;
